import React, {useContext} from 'react';
import {SavedConfigurationsContext, SavedConfigurationsDispatch} from '../context/SavedConfigurationsContext';
import {AuthContext} from "../context/LoginContext";
import ConfigurationsService from "../services/ConfigurationsService";
import {ConfigDispatch} from "../context/ConfigContext";
import {TextSectionsDispatch} from "../context/TextSectionsListContext";
//import defaultData from "../data/defaultData.json";
import {EditTypeContext, EditTypeDispatch} from "../context/EditTypeContext";
import {WorkingSizeDispatch} from "../context/WorkingSizeContext";
import {useLanguage, LOCALE_MAP} from "../context/LanguageContext";

const SavedConfigurationList = () => {
    const {t, language} = useLanguage();
    const editTypeContext = useContext(EditTypeContext);
    const editTypeDispatch = useContext(EditTypeDispatch);
    const savedConfigurations = useContext(SavedConfigurationsContext);
    const savedConfigurationsDispatch = useContext(SavedConfigurationsDispatch);
    const loginContext = useContext(AuthContext);
    const configDispatch = useContext(ConfigDispatch);
    const textSectionsDispatch = useContext(TextSectionsDispatch);
    const workingSizeDispatch = useContext(WorkingSizeDispatch);
    const service = new ConfigurationsService();
    const handleClick = (item) => {
        //console.log(item);
    };
    const updateConfigurationList = async () => {
        const response = await service.getConfigurations();
        //console.log(response);
        savedConfigurationsDispatch({
            type: 'set',
            payload: response
        });

        //getConfigurationsFromOrders
    }
    const deleteConfiguration = async (id) => {
        const response = await service.deleteConfiguration(id);
        //console.log(response);
        await updateConfigurationList();
    }

    function resetTextSections() {
        return new Promise((resolve) => {
            textSectionsDispatch({
                type: 'resetTextSections'
            });
            resolve();
        });
    }

    const editSelectedConfiguration = async (item) => {
        //console.log('editSelectedConfiguration', item);
        const fontConfig = item.fontConfig;
        const textSections = item.textSections;
        const id = item.id;
        const name = item.name;
        //console.log('updateConfiguration', fontConfig, textSections);
        //set config data
        configDispatch({
            type: 'set',
            payload: fontConfig
        });
        await resetTextSections();
        //set text sections
        textSections.map((section, index) => {
            textSectionsDispatch({
                type: 'addTextSection',
                payload: {
                    position: {
                        x: section.position.x,
                        y: section.position.y,
                    },
                    value: section.value,
                    fontSize: section.fontSize,
                    letterSpacing: section.letterSpacing,
                    rawContent: section.rawContent,
                    fontSizeValue: section.fontSizeValue,
                    index: index,
                }
            });
        });
        //set edit type id ,and name
        editTypeDispatch({
            type: 'setId',
            payload: id
        });
        editTypeDispatch({
            type: 'setName',
            payload: name
        });
        editTypeDispatch({
            type: 'setType',
            payload: 'edit'
        });
        workingSizeDispatch({
            type: 'setWorkingSize',
            payload: {
                scale: item.workingSize.scale,
                widthCm: item.workingSize.widthCm,
                heightCm: item.workingSize.heightCm,
            }
        });
        //switch tab
        document.getElementById('conf-tab').click();
    }

    const handleAddToCart = (item) => {
        window.open(process.env.REACT_APP_WC_SITE_URL + 'koszyk?uuid=' + item.id, '_blank');
    };

    const renderConfigurationItems = (fromCart = false) => {
        //console.log('Saved configuration list', savedConfigurations);
        const savedConfigurationsArray = Object.values(savedConfigurations);
        let date = null;
        const filteredItems = savedConfigurationsArray.filter(item =>
            fromCart ? item.fromCart === true : item.fromCart !== true
        );
        return filteredItems.map((item, index) => {
            // Ustal nazwę dla itemów z fromCart === true
            let displayName = item.name;
            if (item.fromCart === true) {
                displayName = item.textSections[0].rawContent;
                date = new Date(item.date).toLocaleDateString(LOCALE_MAP[language], { });
            }
            return (
                <li
                    className="configuration-list__item d-flex justify-content-start"
                    key={index}
                    onClick={() => handleClick(item)}
                    role="listitem"
                    tabIndex="0"
                    aria-label={t('savedConfigurations.configurationLabel', {name: displayName})}
                    style={{
                        padding: "2rem 0",
                        borderBottom: "1px solid #ccc",
                        cursor: "pointer"
                    }}
                >
                    <div className="configuration-list__item-name" style={{fontSize: "1.6rem"}}>
                        <span>{displayName}</span><br/>
                        {item.fromCart === true && (<span>{t('savedConfigurations.purchaseDate', {date})}</span>)}
                    </div>

                    <button
                        style={{marginLeft: "auto", marginRight: '10px'}}
                        className="btn btn-secondary btn-sm configuration-list__item-btn--delete"
                        onClick={e => {
                            e.stopPropagation();
                            deleteConfiguration(item.id);
                        }}
                        aria-label={t('savedConfigurations.deleteLabel', {name: displayName})}
                    >
                        {t('common.delete')}
                    </button>
                    <button
                        style={{marginLeft: "10px", marginRight: '10px'}}
                        className="btn btn--secondary configuration-list__item-btn--edit"
                        onClick={e => {
                            e.stopPropagation();
                            editSelectedConfiguration(item);
                        }}
                        aria-label={t('savedConfigurations.editLabel', {name: displayName})}
                    >
                        {t('common.edit')}
                    </button>
                    {item.fromCart === true && (
                        <button
                            className="btn btn--primary configuration-list__item-btn--add-to-cart"
                            style={{marginLeft: "10px"}}
                            onClick={e => {
                                e.stopPropagation();
                                handleAddToCart(item);
                            }}
                            aria-label={t('savedConfigurations.addToCartLabel', {name: displayName})}
                            type="button"
                        >
                            {t('savedConfigurations.repurchase')}
                        </button>
                    )}
                </li>
            );
        });
    };

    return (
        <div>
            <div className="row" style={{margin: "3rem 0 4rem"}}>
                <div className="col-12 col-md-6">
                    <div className="row">
                        <div className="heading">
                            <div className="heading__line" aria-hidden="true"></div>
                            <h2 className="heading__title">{t('savedConfigurations.workingTemplates')}</h2>
                        </div>
                        {!loginContext.isLoggedIn &&
                            <p>{t('savedConfigurations.loginRequired')}</p>}
                        <ul className="list-group" role="list" aria-label={t('savedConfigurations.savedConfigurationsList')}>
                            {renderConfigurationItems()}
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="row">
                        <div className="heading">
                            <div className="heading__line" aria-hidden="true"></div>
                            <h2 className="heading__title">{t('savedConfigurations.purchasedConfigurations')}</h2>
                        </div>
                        {!loginContext.isLoggedIn &&
                            <p>{t('savedConfigurations.loginRequired')}</p>}
                        <ul className="list-group" role="list" aria-label={t('savedConfigurations.savedConfigurationsList')}>
                            {renderConfigurationItems(true)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SavedConfigurationList;
